import { cn } from '../../lib/cn.ts';

export interface WaveformStripProps {
  bars?: number;
  height?: number;
  className?: string;
  'data-testid'?: string;
}

/**
 * WaveformStrip — a decorative, static audio waveform. Heights are derived
 * deterministically from the bar index (no randomness, no animation) so it is
 * stable and reduced-motion safe. aria-hidden — purely visual.
 */
export function WaveformStrip({
  bars = 32,
  height = 40,
  className,
  'data-testid': testId,
}: WaveformStripProps) {
  const gap = 3;
  const barW = 3;
  const width = bars * (barW + gap);
  const data = Array.from({ length: bars }, (_, i) => {
    const t = i / bars;
    const amp = 0.35 + 0.6 * Math.abs(Math.sin(t * Math.PI * 4));
    const h = amp * height;
    return { x: i * (barW + gap), y: (height - h) / 2, h };
  });
  return (
    <svg
      data-testid={testId}
      aria-hidden="true"
      viewBox={`0 0 ${width} ${height}`}
      className={cn('h-10 w-full', className)}
      preserveAspectRatio="none"
    >
      {data.map((b) => (
        <rect
          key={b.x}
          x={b.x}
          y={b.y}
          width={barW}
          height={b.h}
          rx={1.5}
          className="fill-[var(--color-warm-stone-deep)]"
        />
      ))}
    </svg>
  );
}
